<template>
<div>
    <icon-list
        :event-type="eventType"
    />
</div>
</template>

<script>
import { ref, onUnmounted } from "@vue/composition-api";
import IconList from '../components/icon-list/IconList.vue'

export default {
    components: {
        IconList
    },
    setup() {
        const eventType = ref('facilities')

        return {
            eventType,
        }
    }
}
</script>